var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',_vm._g({staticClass:"more"},_vm.$listeners),[_c('v-icon',[_vm._v("mdi-magnify")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }